<template>

<app-view-list-field :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

    <span v-html="value"></span>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

	computed: {

		value: function() {

			return (this.item.user && this.item.user.wishlist && this.item.user.wishlist.text) ? this.item.user.wishlist.text : '-'

		}

	}

}

</script>
